import { connect } from "react-redux";
import { isNil, equals } from "ramda";
import { Layout } from "react-admin";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import compose from "recompose/compose";
import IconButton from "@material-ui/core/IconButton";
import SOSIcon from "@material-ui/icons/Notifications";
import FacilityBookingIcon from "@material-ui/icons/DateRange";
import React from "react";
import RepairIcon from "@material-ui/icons/Build";

import {
	withRouter
} from "react-router-dom";

import { changeSOSNotification } from "../reducers/sosNotiReducer";
import { changeRepairNotification } from "../reducers/repairNotiReducer";
import { changeFacilityBookingNotification } from "../reducers/facilityBookingReducer";

import SocketIO from "../services/socketIO";
import { HOST, NAME } from "../configs/index";
import { SUPERADMIN } from "../constant/TypeRole";

class MyLayout extends React.Component {
	state = {}

	socket = new SocketIO()

	componentDidMount() {
		this.socket.onReceiveMessage(this.onReceiveMessage);

		this.fetchSOSNoti();
		this.fetchRepairNoti();
		this.fetchFacilityBooking();

		const token = localStorage.getItem("token");

		fetch(`${HOST}/user/me`, {
			headers: { authorization: `Bearer ${token}` },
		}).then((response) => response.json()).then((responseJson) => {
			if (!responseJson.error) {
				const { role: { type }, permission, project } = responseJson;
				if (!equals(type, localStorage.getItem("role")) ||
					!equals(JSON.stringify(permission), isNil(JSON.parse(localStorage.getItem("permission"))) ? undefined : localStorage.getItem("permission")) ||
					!equals(JSON.stringify(project) !== localStorage.getItem("project"))) {
					localStorage.removeItem("token");
					localStorage.removeItem("permission");
					this.props.history.replace("/");
				}
			} else {
				localStorage.removeItem("token");
				localStorage.removeItem("permission");
				this.props.history.replace("/");
			}
		});
	}
	onReceiveMessage = (message) => {
		switch (message) {
		case "sos":
			this.fetchSOSNoti();
			break;
		case "repair":
			this.fetchRepairNoti();
			break;
		case "facility":
			this.fetchFacilityBooking();
			break;
		default:
			break;
		}
	}
	fetchSOSNoti = () => {
		const project = JSON.parse(localStorage.getItem("project"));
		const role = localStorage.getItem("role");
		const token = localStorage.getItem("token");
		const stringProject = role === SUPERADMIN ? "" : `project=${project.join("&project=")}`;
		fetch(`${HOST}/sos?${stringProject}&status=0&_limit=10000`, {
			headers: { authorization: `Bearer ${token}` },
		}).then((response) => response.json()).then((responseJson) => {
			if (!responseJson.error) {
				// const notiCount = responseJson.filter(res => res.status === 0);
				this.props.changeSOSNotification(responseJson.length);
			}
		});
	}
	fetchRepairNoti = () => {
		const project = JSON.parse(localStorage.getItem("project"));
		const role = localStorage.getItem("role");
		const token = localStorage.getItem("token");
		const stringProject = role === SUPERADMIN ? "" : `project=${project.join("&project=")}`;
		fetch(`${HOST}/repair?${stringProject}&status=1&_limit=10000`, {
			headers: { authorization: `Bearer ${token}` },
		}).then((response) => response.json()).then((responseJson) => {
			if (!responseJson.error) {
				// const notiCount = responseJson.filter(res => res.status === 1);
				this.props.changeRepairNotification(responseJson.length);
			}
		});
	}
	fetchFacilityBooking = () => {
		const project = JSON.parse(localStorage.getItem("project"));
		const role = localStorage.getItem("role");
		const token = localStorage.getItem("token");
		const stringProject = role === SUPERADMIN ? "" : `project=${project.join("&project=")}`;
		fetch(`${HOST}/facilitybooking?${stringProject}&status_ne=2&_limit=10000`, {
			headers: { authorization: `Bearer ${token}` },
		}).then((response) => response.json()).then((responseJson) => {
			if (!responseJson.error) {
				// const notiCount = responseJson.filter(res => res.status === 1);
				this.props.changeFacilityBookingNotification(responseJson.length);
			}
		});
	}
	componentWillUnmount() {
		this.socket.disconnect();
	}
	render() {
		const { classes, sosNoti, repairNoti, facilityBookingNoti } = this.props;
		console.log(facilityBookingNoti);
		return (
			<Layout
				{...this.props}
				title={(
					<div>
						<span style={{ lineHeight: "55px" }}>
							{NAME}
						</span>
						<Link to='/sos' >
							<IconButton style={{ float: "right", marginTop: 7 }}>
								<SOSIcon className={classNames(classes.notificationbutton)} />
								{
									sosNoti ?
										<div style={{
											width: 24, height: 24,
											position: "absolute",
											borderRadius: 12,
											background: "red",
											top: 0, right: 0
										}}>
											<span style={{
												fontSize: 12,
												color: "white",
												position: "absolute", left: 0, right: 0,
												lineHeight: "23px"
											}}>
												{sosNoti}
											</span>
										</div>
										: null
								}
							</IconButton>
						</Link>
						<Link to='/repair' >
							<IconButton style={{ float: "right", marginTop: 7 }}>
								<RepairIcon className={classNames(classes.notificationbutton)} />
								{
									repairNoti ?
										<div style={{
											width: 24, height: 24,
											position: "absolute",
											borderRadius: 12,
											background: "red",
											top: 0, right: 0
										}}>
											<span style={{
												fontSize: 12,
												color: "white",
												position: "absolute", left: 0, right: 0,
												lineHeight: "23px"
											}}>
												{repairNoti}
											</span>
										</div>
										: null
								}
							</IconButton>
						</Link>
						<Link to='/facilitybooking' >
							<IconButton style={{ float: "right", marginTop: 7 }}>
								<FacilityBookingIcon className={classNames(classes.notificationbutton)} />
								{
									facilityBookingNoti ?
										<div style={{
											width: 24, height: 24,
											position: "absolute",
											borderRadius: 12,
											background: "red",
											top: 0, right: 0
										}}>
											<span style={{
												fontSize: 12,
												color: "white",
												position: "absolute", left: 0, right: 0,
												lineHeight: "23px"
											}}>
												{facilityBookingNoti}
											</span>
										</div>
										: null
								}
							</IconButton>
						</Link>
					</div>
				)}
			/>
		);
	}
}

const styles = theme => ({
	notificationbutton: {
		color: "white"
	}
});

const mapStateToProps = state => ({
	sosNoti: state.sosNoti,
	repairNoti: state.repairNoti,
	facilityBookingNoti: state.facilityBookingNoti
});

export default compose(
	withRouter,
	connect(
		mapStateToProps,
		{
			changeSOSNotification,
			changeRepairNotification,
			changeFacilityBookingNotification
		}
	),
	withStyles(styles)
)(MyLayout);


// export default connect(undefined, { userLogout: userLogout() })(MyLogoutButton);


// WEBPACK FOOTER //
// ./src/components/Layout.js